import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useCallback, useRef, useEffect } from 'react';
import { FiltersProvider } from './FilterGroup.Context/provider.es.js';
import { FilterDateRange } from './FilterGroup.DateRange/FilterGroup.DateRange.es.js';
import { FilterDropdown } from './FilterGroup.Dropdown/FilterGroup.Dropdown.es.js';
import { FilterInput } from './FilterGroup.Input/FilterGroup.Input.es.js';
import { FilterGroupMainButton } from './FilterGroup.MainButton/FilterGroup.MainButton.es.js';
import { MultiFilterDropdown } from './FilterGroup.MultiFilterDropdown/FilterGroup.MultiFilterDropdown.es.js';
import { FilterRadioGroup } from './FilterGroup.RadioGroup/FilterGroup.RadioGroup.es.js';

/**
 * EDS Filter Group Component.
 */ const FilterGroup = ({ className, children, dropDirection = 'down', ...providerProps })=>{
    const [isOpen, setIsOpen] = useState(false);
    const handleFilterButtonClick = useCallback(()=>{
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { menuDisplays } = providerProps;
    const filterGroupDropdownRef = useRef(null);
    const handleClickOutside = useCallback((e)=>{
        if (filterGroupDropdownRef.current && !filterGroupDropdownRef.current.contains(e.target)) {
            setIsOpen(false);
        }
    }, []);
    useEffect(()=>{
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    return jsx(FiltersProvider, {
        ...providerProps,
        children: jsxs("div", {
            "data-testid": "filter-group",
            children: [
                jsx(FilterGroupMainButton, {
                    isOpen: isOpen,
                    onClick: handleFilterButtonClick
                }),
                jsx("div", {
                    ref: filterGroupDropdownRef,
                    children: jsx(MultiFilterDropdown, {
                        dropDirection: dropDirection,
                        isOpen: isOpen,
                        menuDisplays: menuDisplays,
                        children: children
                    })
                })
            ]
        })
    });
};
FilterGroup.displayName = 'FilterGroup';
FilterGroup.DateRange = FilterDateRange;
FilterGroup.Input = FilterInput;
FilterGroup.Dropdown = FilterDropdown;
FilterGroup.RadioGroup = FilterRadioGroup;

export { FilterGroup, FilterGroup as default };
//# sourceMappingURL=FilterGroup.es.js.map
